import React, { Component } from 'react';
//import Avatar from '../../../assets/images/avatar.png';
//const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/tour/';




export default class TourLeadPage extends Component {
    // constructor() {
    //     super();
    // }

    AddSpecialChar = (str) => {
        if (str !== '' && str !== undefined && str !== null)
            return str.replace(/pnk_Amp/g, "&");
    }


    render() {
        return (
            <div>
                <div class="tour-leads-list-main">
                    <div class="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <h3>Tour Leads</h3>
                            </div>

                        </div>

                        <div class="organizers-list-div">
                            <div class="row">
                                <div class="col-md-12 col-lg-12 organizers-head-list-desktop">
                                    <div class="row">
                                        <div class="col-md-1 col-lg-1">
                                            <div class="users-list-head">
                                                <h6>Sr.No.</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h6>Tour Name</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-1 col-lg-1">
                                            <div class="users-list-head">
                                                <h6>Pricing</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h6>Duration</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h6>User Name</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h6>User Number</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h6>Lead Date</h6>
                                            </div>
                                        </div>



                                    </div>

                                </div>
                                <div class="col-md-12 col-lg-12 organizers-list-desktop">
                                    {this.props.mystate.leadsList.length > 0 ?

                                        this.props.mystate.leadsList.map((item, i) => (

                                            <div class="users-list-details" >
                                                <div class="row">
                                                    <div class="col-md-1 col-lg-1">
                                                        <div class="users-list-content">
                                                            <p>{i + 1}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="users-list-content">
                                                            <p>{this.AddSpecialChar(item.tour_details[0].tour_name)}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-1 col-lg-1">
                                                        <div class="users-list-content">
                                                            <p>Rs. {this.AddSpecialChar(item.tour_details[0].tour_pricing)}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="users-list-content">
                                                            <p>{this.AddSpecialChar(item.tour_details[0].tour_duration)}</p>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="users-list-content">
                                                            <p>{item.user_details[0].user_full_name}</p>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="users-list-content">
                                                            <p>{item.user_details[0].user_mobile}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                    <div class="users-list-content">
                                                        <p>{item.added_on}</p>
                                                    </div>
                                                </div>

                                                </div>



                                            </div>
                                        ))
                                        : ''}

                                </div>

                            

                                <div class="col-md-12 col-lg-12 organizers-list-mobile">
                                    {this.props.mystate.leadsList.length > 0 ?

                                        this.props.mystate.leadsList.map((item, i) => (

                                            <div class="users-list-details">
                                                <div class="row">
                    
                                                  
                                                    <div class="col-6">


                                                        <div class="users-list-content">
                                                            <p>{this.AddSpecialChar(item.tour_details[0].tour_name)}</p>
                                                        </div>

                                                        <div class="users-list-content">
                                                            <p>{this.AddSpecialChar(item.tour_details[0].tour_theme)}</p>
                                                        </div>


                                                        <div class="users-list-content">
                                                            <p>Rs. {this.AddSpecialChar(item.tour_details[0].tour_pricing)}</p>
                                                        </div>

                                                      

                                                    </div>
                                                    <div class="col-6">
                                                    <div class="users-list-content">
                                                    <p>{item.user_details[0].user_full_name}</p>
                                                </div>

                                                <div class="users-list-content">
                                                    <p>{item.user_details[0].user_mobile}</p>
                                                </div>
                                                <div class="users-list-content">
                                                <p style={{fontWeight:'bold'}}>{item.added_on}</p>
                                            </div>

                                                    </div>
                                                </div>



                                            </div>
                                        ))
                                        : ''}

                                </div>

                                                   

                            </div>

                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

